var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCPlusPlus = function SvgCPlusPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c-plus-plus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.278 37.5c.35-.604.566-1.284.566-1.895v-21.21c0-.61-.217-1.291-.565-1.895L22.628 25l21.65 12.5Z",
    fill: "#00599C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.552 49.542 42.92 38.937c.529-.305 1.01-.833 1.358-1.437L22.629 25 .978 37.5c.348.604.83 1.132 1.358 1.437l18.368 10.605c1.058.61 2.79.61 3.848 0Z",
    fill: "#004482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.279 12.5c-.35-.604-.83-1.132-1.36-1.437L24.553.458c-1.058-.61-2.79-.61-3.848 0L2.336 11.063c-1.058.61-1.924 2.11-1.924 3.332v21.21c0 .61.217 1.291.565 1.895L22.627 25 44.28 12.5Z",
    fill: "#659AD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.628 39.812c-8.167 0-14.81-6.643-14.81-14.81 0-8.167 6.643-14.81 14.81-14.81 5.27 0 10.184 2.835 12.826 7.4l-6.41 3.709a7.436 7.436 0 0 0-6.416-3.704c-4.084 0-7.405 3.322-7.405 7.405s3.321 7.405 7.405 7.405a7.437 7.437 0 0 0 6.416-3.705l6.41 3.71a14.864 14.864 0 0 1-12.826 7.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.439 24.177h-1.646V22.53h-1.645v1.646h-1.646v1.645h1.646v1.646h1.645v-1.646h1.646v-1.645ZM43.61 24.177h-1.646V22.53h-1.645v1.646h-1.646v1.645h1.646v1.646h1.645v-1.646h1.646v-1.645Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c-plus-plus_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.412)",
    d: "M0 0h44.431v50H0z"
  })))));
};

export default SvgCPlusPlus;